var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTransactionsLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Core-Components",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons",
    transform: "translate(-248.000000, -654.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon/Entity-Copy",
    transform: "translate(248.000000, 654.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "attach_money-24px"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "0 0 24 0 24 24 0 24"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M13,2 L13.0002215,4.11251002 C15.0212565,4.46972887 16.4960514,5.71337714 17.18,7.66 L17.18,7.66 L15.374,8.71 C14.765,6.883 13.547,5.98 11.72,5.98 C10.103,5.98 8.843,6.694 8.843,7.891 C8.843,9.214 10.019,9.949 12.686,10.474 C15.899,11.083 17.432,12.427 17.432,14.863 C17.432,16.102 16.928,17.152 15.941,18.013 C15.1545548,18.6990479 14.1814501,19.1051067 13.0004388,19.2418 L13,21.5 L11,21.5 L11.0001507,19.228584 C8.24400901,18.8756631 6.4780427,17.1227348 6.029,14.653 L6.029,14.653 L8.024,13.624 C8.444,16.081 9.788,17.32 12.035,17.32 C13.904,17.32 15.164,16.27 15.164,14.947 C15.164,13.456 14.051,12.763 11.426,12.259 C8.486,11.671 6.701,10.285 6.701,7.933 C6.701,6.778 7.163,5.833 8.108,5.098 C8.89095455,4.48903535 9.84689472,4.13954915 10.9997076,4.03759784 L11,2 L13,2 Z",
    id: "Combined-Shape",
    fill: "#677283",
    fillRule: "nonzero"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransactionsLogo);
export default __webpack_public_path__ + "static/media/TransactionsLogo.b3d941a2e3b4dcd7570c9b07b2749374.svg";
export { ForwardRef as ReactComponent };